<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-card elevation="0" class="pa-2">

      <v-card-title class="text-h5 word-break"><strong>404 Not Found</strong></v-card-title>

      <v-card-text class="text-body-1">

        <p>The requested page cannot be found.</p>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

export default Vue.extend({

  name: 'DateTime',

  methods: {

    clearSnackbars() {

      this.snackbars.genericInfoSnackbar = false;

      this.snackbars.genericErrorSnackbar = false;

    },

  },

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

        let query = await axios.get('api/Date/GetDateTime');

        this.loading = false;

        this.currentDateTime = query.data;

      }
      catch (error:any)
      {
        // an exception has been thrown

        if (error.response && error.response.status == 401) {

          // the exception was unauthorized, redirect to login screen

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }
        else {

          this.clearSnackbars();

          this.snackbars.genericErrorText = 'There was an issue contacting the server.';

          this.snackbars.genericErrorSnackbar = true;

        }

      }

    }, 200)

  },

  data () {

    return {

      loading: false,

      currentDateTime: '',

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

      }

    }

  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

th > .v-icon {

  color: white !important;

}

th, td {

  font-size: 18px !important;

}

</style>
